import { CommonRemoteDataSource } from '@base-data-sources';
import { IBaseDataSourceRepository } from '@base-repositories';
import { BaseEntity, BaseDataSourceConstructorEntity } from '@base-entities';

export function makeCommonDataSource<E extends BaseEntity = BaseEntity>(
  params: BaseDataSourceConstructorEntity,
): IBaseDataSourceRepository<E> {
  return new CommonRemoteDataSource<E>(params);
}
